module.exports = {
  pathPrefix: '/', // Prefix for all links. If you deploy your site to example.com/portfolio your pathPrefix should be "portfolio"

  siteTitle: '#OneDevMinute with Ahmad Awais', // Navigation and Site Title
  siteTitleAlt: '#OneDevMinute with Ahmad Awais', // Alternative Site title for SEO
  titleHash: '#OneDevMinute',
  titleWith: 'with Ahmad Awais',
  siteUrl: 'https://OneDevMinute.AhmadAwais.com', // Domain of your site. No trailing slash!
  siteLanguage: 'en', // Language Tag on <html> element
  siteBanner: '/social/OneDevMinute.jpg', // Your image for og:image tag. You can find it in the /static folder
  favicon: 'src/favicon.png', // Your image for favicons. You can find it in the /src folder
  siteDescription:
    '#OneDevMinute with Ahmad Awais. Learn one thing about development in one minute on a daily basis with Ahmad Awais', // Your site description
  author: 'Ahmad Awais', // Author for schemaORGJSONLD
  siteLogo: '/social/logo.png', // Image for schemaORGJSONLD

  // siteFBAppID: '123456789', // Facebook App ID - Optional
  userTwitter: '@MrAhmadAwais', // Twitter Username - Optional
  ogSiteName: 'AhmadAwais', // Facebook Site Name - Optional
  ogLanguage: 'en_US', // Facebook Language

  // Manifest and Progress color
  // See: https://developers.google.com/web/fundamentals/web-app-manifest/
  themeColor: '#fad000',
  backgroundColor: '#7726F4',

  // Settings for typography.js
  headerFontFamily: 'Bitter',
  bodyFontFamily: 'Open Sans',
  baseFontSize: '18px',
};
